import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { AddDiscountCodeDialogComponent } from './add-discount-code-dialog.component'
import { DiscountCode } from '@tokeet-frontend/discount-codes'

@Injectable()
export class AddDiscountCodeDialogService {
  constructor(private dialog: DialogService) {}

  open(data?: { defaults?: Partial<DiscountCode> }) {
    const defaultConfig: MatDialogConfig = {
      width: '830px',
      height: 'auto',
      data: { ...data },
    }

    return this.dialog.openVariableDialog(AddDiscountCodeDialogComponent, defaultConfig)
  }
}
